import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import App from "./App";
import { wansightTheme } from "./theme";
import { GeoSettingsProvider } from "./contexts/GeoSettingsContext";
import "antd/dist/reset.css";
import "./theme.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      theme={{ ...wansightTheme, algorithm: theme.defaultAlgorithm }}
    >
      <BrowserRouter>
        <GeoSettingsProvider>
          <App />
        </GeoSettingsProvider>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);
